import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c548d2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = { class: "flex-box" }
const _hoisted_3 = { class: "batch-info-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "批次ID：", -1))
const _hoisted_5 = { class: "batch-info-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "所属企业：", -1))
const _hoisted_7 = { class: "flex-box" }
const _hoisted_8 = { class: "batch-info-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "卡名称：", -1))
const _hoisted_10 = { class: "batch-info-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "面额：", -1))
const _hoisted_12 = { class: "batch-info-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "数量：", -1))
const _hoisted_14 = { style: {"margin-right":"10px"} }
const _hoisted_15 = { class: "num-red" }
const _hoisted_16 = { class: "form-box" }
const _hoisted_17 = { class: "left" }
const _hoisted_18 = { class: "search-wrap" }
const _hoisted_19 = {
  key: 0,
  class: "tree-wrap"
}
const _hoisted_20 = { style: {"display":"flex","justify-content":"space-between","padding":"5px 30px 5px 10px"} }
const _hoisted_21 = {
  key: 1,
  class: "tree-wrap"
}
const _hoisted_22 = { class: "tree-node-item" }
const _hoisted_23 = { class: "tree-node-item" }
const _hoisted_24 = { class: "right" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "删除", -1))
const _hoisted_26 = { class: "form-box-bottom" }
const _hoisted_27 = { class: "tips" }
const _hoisted_28 = {
  key: 1,
  class: "preview-box"
}
const _hoisted_29 = { class: "tips" }
const _hoisted_30 = { class: "num-red" }
const _hoisted_31 = { class: "num-red" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_app_user_input = _resolveComponent("app-user-input")!
  const _component_PlusCircleOutlined = _resolveComponent("PlusCircleOutlined")!
  const _component_a_tree = _resolveComponent("a-tree")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visible) = $event)),
    width: "1000px",
    title: "绑定预付卡",
    onCancel: _ctx.handleCancel
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        key: "back",
        onClick: _ctx.handleCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode("取 消")
        ]),
        _: 1
      }, 8, ["onClick"]),
      (_ctx.isShowPreview)
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: "last",
            onClick: _ctx.lastStep
          }, {
            default: _withCtx(() => [
              _createTextVNode("上一步")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : (_openBlock(), _createBlock(_component_a_button, {
            key: "next",
            type: "primary",
            onClick: _ctx.nextStep
          }, {
            default: _withCtx(() => [
              _createTextVNode("下一步")
            ]),
            _: 1
          }, 8, ["onClick"])),
      (_ctx.isShowPreview)
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: "submit",
            type: "primary",
            loading: _ctx.loading,
            onClick: _ctx.batchDistribute
          }, {
            default: _withCtx(() => [
              _createTextVNode("确认分配")
            ]),
            _: 1
          }, 8, ["loading", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("span", null, _toDisplayString(_ctx.batchInfo.batchId), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", null, _toDisplayString(_ctx.batchInfo.enterpriseName), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("span", null, _toDisplayString(_ctx.batchInfo.cardName), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("span", null, _toDisplayString(_ctx.batchInfo.nominalAmount) + " 元", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.batchInfo.num) + "张", 1),
          _createElementVNode("span", null, [
            _createTextVNode("剩余可分配 "),
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.batchInfo.allocatableNum), 1),
            _createTextVNode(" 张")
          ])
        ])
      ]),
      _createVNode(_component_a_divider, {
        orientation: "left",
        dashed: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode("选择用户")
        ]),
        _: 1
      }),
      (!_ctx.isShowPreview)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_app_user_input, {
                    style: {"width":"200px"},
                    placeholder: "员工/手机号",
                    "is-need-user-info": true,
                    "enterprise-id": _ctx.batchInfo.enterpriseId,
                    onGetUserInfo: _ctx.getUserInfo
                  }, null, 8, ["enterprise-id", "onGetUserInfo"])
                ]),
                (_ctx.showUserList)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("ul", null, [
                        _createElementVNode("li", _hoisted_20, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.userList.unSelect[0].userName) + "(" + _toDisplayString(_ctx.userList.unSelect[0].phone) + ")", 1),
                          _createVNode(_component_PlusCircleOutlined, {
                            style: {"color":"#1890ff"},
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addUser(_ctx.userList.unSelect[0])))
                          })
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createVNode(_component_a_tree, {
                        "tree-data": _ctx.departmentList,
                        "load-data": _ctx.onLoadData,
                        placeholder: "部门名称",
                        "tree-node-filter-prop": "title"
                      }, {
                        title: _withCtx((nodeData) => [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("span", null, _toDisplayString(nodeData.title), 1),
                            (nodeData.isLeaf || nodeData.hasUser)
                              ? (_openBlock(), _createBlock(_component_PlusCircleOutlined, {
                                  key: 0,
                                  class: "icon",
                                  onClick: ($event: any) => (_ctx.addUser(nodeData,'node'))
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }, 8, ["tree-data", "load-data"]),
                      _createVNode(_component_a_tree, {
                        "tree-data": _ctx.tempAccountList,
                        "tree-node-filter-prop": "title"
                      }, {
                        title: _withCtx((nodeData) => [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("span", null, _toDisplayString(nodeData.title), 1),
                            (nodeData.userCode)
                              ? (_openBlock(), _createBlock(_component_PlusCircleOutlined, {
                                  key: 0,
                                  class: "icon",
                                  onClick: ($event: any) => (_ctx.addUser(nodeData,'node'))
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }, 8, ["tree-data"])
                    ]))
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_a_table, {
                  bordered: "",
                  "row-key": "userCode",
                  "data-source": _ctx.dataSource,
                  columns: _ctx.columns
                }, {
                  operation: _withCtx(({record, index}) => [
                    (_ctx.dataSource.length)
                      ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                          key: 0,
                          title: "确定删除嘛?",
                          onConfirm: ($event: any) => (_ctx.onDelete(index,record))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_25
                          ]),
                          _: 2
                        }, 1032, ["onConfirm"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["data-source", "columns"])
              ])
            ]),
            _createVNode(_component_a_divider, { orientation: "left" }),
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_a_form, {
                ref: "formRef",
                model: _ctx.formState,
                rules: _ctx.rules,
                "label-col": _ctx.labelCol,
                "wrapper-col": _ctx.wrapperCol
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_27, "已选择 " + _toDisplayString(_ctx.dataSource.length) + " 人", 1),
                  _createVNode(_component_a_form_item, {
                    label: "每人分配",
                    name: "cardNumEachPerson"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_number, {
                        value: _ctx.formState.cardNumEachPerson,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.cardNumEachPerson) = $event)),
                        min: 1,
                        precision: 0,
                        style: {"width":"35%"}
                      }, null, 8, ["value"]),
                      _createTextVNode(" 张 ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, {
                    label: "绑定用户排重",
                    name: "excludeRepeatRule"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio_group, {
                        value: _ctx.formState.excludeRepeatRule,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.excludeRepeatRule) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio, { value: "NOT_EXCLUDE" }, {
                            default: _withCtx(() => [
                              _createTextVNode("不排重")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_radio, { value: "CURRENT_TIME_EXCLUDE" }, {
                            default: _withCtx(() => [
                              _createTextVNode("本次排重")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_radio, { value: "CURRENT_BATCH_EXCLUDE" }, {
                            default: _withCtx(() => [
                              _createTextVNode("批次内排重")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules", "label-col", "wrapper-col"])
            ])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.isShowPreview)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createVNode(_component_a_table, {
              bordered: "",
              "row-key": "userCode",
              "data-source": _ctx.previewUserList,
              columns: _ctx.previewColumns
            }, null, 8, ["data-source", "columns"]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("p", null, [
                _createTextVNode("本次将发放 "),
                _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.previewInfo.personNum), 1),
                _createTextVNode(" 人，总计 "),
                _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.previewInfo.cardTotalNum), 1),
                _createTextVNode(" 张")
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "onCancel"]))
}